// export LeftMenu from './LeftMenu';
// export TopMenu from './TopMenu';
// export Tabs from './Tabs';
// export PortalTabItem from './PortalTabItem';
import * as SystemSetting from '../system-setting'
import * as AccountCenter from '../account-center'
import * as Home from '../home'

const PortalComponents = {
  'system-setting': SystemSetting,
  'account-center': AccountCenter,
  'home': Home,
}

export default PortalComponents



// WEBPACK FOOTER //
// ./src/common/components/portal/index.jsx